import React from 'react';
import LoopRing from './LoopRing';

// The white paper's first page, used as the masthead of the home page and of /whitepaper/.
export default function Cover({
  id = 'top',
  runningHead,
  eyebrow,
  title,
  subtitle,
  lead,
  actions,
  meta,
  ringSteps,
  guides = true,
}) {
  return (
    <section className="cover theme-dark" id={id} data-nav-tone="dark">
      {guides ? <div className="cover__guides" aria-hidden="true" /> : null}
      <div className="container container--wide cover__inner">
        {runningHead ? (
          <p className="cover__running">
            <span>{runningHead[0]}</span>
            <span>{runningHead[1]}</span>
          </p>
        ) : null}
        <div className="cover__copy">
          <p className="eyebrow cover__eyebrow">{eyebrow}</p>
          <h1 className="cover__title">{title}</h1>
          <p className="cover__subtitle">{subtitle}</p>
        </div>
        <div className="cover__ring">
          <LoopRing labelled steps={ringSteps} />
        </div>
        <div className="cover__rule" aria-hidden="true" />
        <p className="cover__lead">{lead}</p>
        {actions ? <div className="cover__actions">{actions}</div> : null}
        {meta ? (
          <dl className="cover__meta">
            {meta.map(([label, value]) => (
              <div key={label}>
                <dt>{label}</dt>
                <dd>{value}</dd>
              </div>
            ))}
          </dl>
        ) : null}
      </div>
    </section>
  );
}
